import React, {useEffect, useState} from "react";
import PageLoadingSpinner from "../../PageLoadingSpinner";
import {getRanking} from "../../../services/Trading";
import EmptyPeriodState from "../../EmptyPeriodState";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {
    RankingList,
    RankingColHeader,
    RankingColHeaderInner,
    RankingRow,
    RankingRowInner,
    RankingProgressTrack,
    RankingProgressFillLoss,
    RankingPairLabel,
} from "../RankingCardStyles";

export default function CardRankingLoss({filter, ...props}) {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const { t } = useTranslation();

    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    useEffect(() => {
        setLoading(true);
        getRanking({
            typeWinOrLoss: 'LOSS',
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
            direction: filter[0].direction,
        }).then((data) => {
            if (!data || data === '') {
                return;
            }

            setList(data.data);
            setLoading(false);
        });

        return function cleanup() {
            setList([]);
        };
    }, [filter]);

    return (
        <div {...props}>
            <div className="card shadow mb-4 h-100">
                <div className="card-header py-3">
                    <div className="row">
                        <div className="col d-flex flex-column justify-content-center">
                            <span className="m-0 font-weight-bold">
                                <nobr>
                                    <i className="far fa-frown fa-1x"/> {t('report_worst_currency_pairs_title')}
                                </nobr>
                            </span>
                        </div>
                        <div className="col">
                            <div className="float-right">
                                <span className="badge badge-danger">Top 5</span><br/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body pb-0 mb-0">
                    {isActiveSignature ?
                        <div className="row">
                            <div className="col">
                                {loading ? (
                                    <PageLoadingSpinner minHeight={130} padding="20px 16px"/>
                                ) : (
                                    <React.Fragment>
                                        {list && list.data && list.data.length ?
                                            <RankingList>
                                                <RankingColHeader>
                                                    <RankingColHeaderInner>
                                                        <span>{t('report_worst_currency_pairs_col_1')}</span>
                                                        <span>{t('currency_pairs')}</span>
                                                    </RankingColHeaderInner>
                                                </RankingColHeader>
                                                {list.data.map((row) => {
                                                    const pct = row.qtdeTotal
                                                        ? Math.max(6, (row.count * 100) / row.qtdeTotal)
                                                        : 0;
                                                    return (
                                                        <RankingRow key={row.id}>
                                                            <RankingRowInner>
                                                                <RankingProgressTrack>
                                                                    <RankingProgressFillLoss
                                                                        style={{width: `${pct}%`}}
                                                                        role="progressbar"
                                                                        aria-valuenow={row.count}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={row.qtdeTotal}
                                                                    >
                                                                        <span>{row.count}/{row.qtdeTotal}</span>
                                                                    </RankingProgressFillLoss>
                                                                </RankingProgressTrack>
                                                                <RankingPairLabel title={row.currencyPair}>
                                                                    {row.currencyPair}
                                                                </RankingPairLabel>
                                                            </RankingRowInner>
                                                        </RankingRow>
                                                    );
                                                })}
                                            </RankingList> :
                                            <EmptyPeriodState iconClassName="fas fa-chart-line"/>
                                        }
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        : <>
                            <div className="alert alert-primary text-center" role="alert">
                                {t('signature_text_acess_all_resources')}
                                <br/>
                                <Link className="btn btn-success btn-sm font-weight-bold mt-4" to="/plans">
                                    {t('signature_btn')}
                                </Link>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
}
